/* eslint-disable import/prefer-default-export */
import { createComponent } from '@carvana/merch-components';
import styled from 'styled-components';
import { PrimaryButton } from '@/common/Button';

export const MobileLineBreak = createComponent('br', {
  className: 'm:hidden'
});

export const FlexWrapper = styled.div.attrs({
  className: 'flex flex-wrap gap-16 justify-center m-auto mt-24 m:mt-48'
})`
  max-width: 1200px;
`;

export const ViewAllButton = styled(PrimaryButton).attrs({
  className: 'mt-24 mx-24'
})`
  width: 218px;
`;

export const ViewMoreButton = createComponent('div', {
  className: 'ml-8 mt-24 flex items-center gap-4 text-blue-2 tl-label-m'
});
